import React from 'react';
import { InfoIcon } from 'components/Icons/Info';
import { Popover, PopoverProps } from '../index';
import cn from './styles.module.scss';

export const InfoPopover = (props: PopoverProps) => (
  <Popover
    classNames={{
      root: cn.root,
    }}
    trigger="click"
    placement="right"
    destroyOnHidden
    {...props}
  >
    <span>{props.children || <InfoIcon className={cn.icon} />}</span>
  </Popover>
);
